"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var PayCodeTypeResource = /** @class */ (function (_super) {
    tslib_1.__extends(PayCodeTypeResource, _super);
    function PayCodeTypeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayCodeTypeResource.endpoint = '/paycodetypes';
    PayCodeTypeResource.MODEL_NAME = 'paycodetype';
    return PayCodeTypeResource;
}(base_1.default));
exports.default = PayCodeTypeResource;
//# sourceMappingURL=paycodetype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/paycodetype.js
// module id = 9BlP
// module chunks = 0